//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Langerhans_cell_histiocytosis",
  data() {
    return {
      form: {
        limb: "",
        breath: "",
        loop: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "＞2岁" },
        { value: "1", name: "＜2岁" },
      ],
      dataList2: [
        { value: "0", name: "＜4个" },
        { value: "1", name: "≥4个" },
      ],
      dataList3: [
        { value: "0", name: "无" },
        { value: "1", name: "有" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Langerhans_cell_histiocytosis.vue